module.exports = __webpack_public_path__ + "jingTai/img/two2.bdcca27b.png";